import * as MobileDeviceHelpers from '@dmi/mobile/app/utils/deviceHelpers';

export default MobileDeviceHelpers;
